// extracted by mini-css-extract-plugin
module.exports = {"panel":"Welcome_panel__14XUc","panel-inner":"Welcome_panel-inner__FbcO0","title":"Welcome_title__3rXuz","line":"Welcome_line__KC0TA","arrow":"Welcome_arrow__24iVv"};